import Seo from "../components/Seo";
import useContactInfo from "../lib/useContact";

export default function Terms() {
  const biz = useContactInfo();
  return (
    <div data-testid="terms-page" className="pt-28 bg-white">
      <Seo
        title="Website Terms | Zarco's Decks & Outdoor Living"
        description="Website terms of use for Zarco's Decks & Outdoor Living, a family-owned deck builder serving North Georgia and Metro Atlanta."
      />
      <section className="px-6 md:px-12 lg:px-20 py-16 md:py-24 max-w-3xl">
        <p className="text-xs uppercase tracking-[0.3em] text-[#99582A] font-semibold">Legal</p>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight font-medium mt-4 text-[#111]">
          Website Terms
        </h1>
        <p className="mt-3 text-sm text-[#666]">Last updated: September 2026</p>

        <div className="mt-10 space-y-8 text-[#4A4A4A] leading-relaxed text-sm md:text-base">
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">About this website</h2>
            <p className="mt-2">
              This website is operated by Zarco's Decks & Outdoor Living ("Zarco's"). It provides
              general information about our services and a way to request a free, no-obligation
              estimate. Content on this site — including product names, colors, and options from
              manufacturers such as TimberTech — is provided for general guidance and may change;
              exact products, colors, warranty coverage, and pricing are always confirmed in your
              written proposal.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Estimates</h2>
            <p className="mt-2">
              Submitting the estimate form or using the website assistant does not create a
              contract. A project begins only after you approve a written proposal from Zarco's.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Accuracy</h2>
            <p className="mt-2">
              We work hard to keep this website accurate, but screen colors vary from physical
              materials and manufacturer catalogs change. We recommend viewing physical samples
              before making final selections. Nothing on this website is a guarantee of price,
              availability, or schedule.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Intellectual property</h2>
            <p className="mt-2">
              Project photographs on this site show real Zarco's Decks & Outdoor Living work and
              may not be reused without permission. TimberTech and related product names are
              trademarks of their respective owners.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl tracking-tight font-medium text-[#111]">Contact</h2>
            <p className="mt-2">
              Questions about these terms:{" "}
              <a href={biz.emailHref} className="text-[#99582A] underline">{biz.email}</a> or{" "}
              <a href={biz.phoneMainHref} className="text-[#99582A] underline">{biz.phoneMain}</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
